// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Autocomplete_wrapper__Wmo5c"};